import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { getAuthHeader, serverUrl } from ".";

export const usePostMaterialNotice = ({
  department,
  directory,
}: {
  department: string;
  directory: string;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ content }: { content: string }) => {
      const response = await axios.post(
        `${serverUrl}/materials/notice`,
        {
          department,
          directory,
          content,
        },
        getAuthHeader()
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["materialDirectoryDetail", department, directory],
      });
    },
  });
};

export const useMaterialDirectories = () => {
  return useQuery({
    queryKey: ["materialDirectories"],
    queryFn: async () => {
      const response = await axios.get(
        `${serverUrl}/materials/dirs`,
        getAuthHeader()
      );
      return response.data;
    },
  });
};

export const useMaterialDirectoryDetail = ({
  department,
  directory,
}: {
  department?: string;
  directory?: string;
}) => {
  return useQuery({
    queryKey: ["materialDirectoryDetail", department, directory],
    queryFn: async () => {
      const response = await axios.get(
        `${serverUrl}/materials/${department}/${directory}`,
        getAuthHeader()
      );
      return response.data;
    },
    enabled: !!department && !!directory,
  });
};

export const useUploadMaterialFile = ({
  department,
  directory,
}: {
  department: string;
  directory: string;
}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      filename,
      file,
    }: {
      filename: string;
      file: File;
    }) => {
      const formData = new FormData();
      formData.append(filename, file);
      formData.append("metadata", JSON.stringify({ department, directory }));

      await axios.post(
        `${serverUrl}/materials/upload`,
        formData,
        getAuthHeader()
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["materialDirectoryDetail", department, directory],
      });
    },
  });
};
